'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _recompose = require('recompose');

var _reactRedux = require('react-redux');

var _paymentService = require('../payment/paymentService');

var _currentUserActions = require('../../currentUserActions');

var _paymentSelector = require('../payment/paymentSelector');

var _LoadingTransitionDisplay = require('../../../components/loaders/LoadingTransitionDisplay');

var _LoadingTransitionDisplay2 = _interopRequireDefault(_LoadingTransitionDisplay);

var _loadingTransitionDecorator = require('../../../components/loaders/loadingTransitionDecorator');

var _loadingTransitionDecorator2 = _interopRequireDefault(_loadingTransitionDecorator);

var _UnsubscribeConfirm = require('./UnsubscribeConfirm');

var _UnsubscribeConfirm2 = _interopRequireDefault(_UnsubscribeConfirm);

var _UnsubscribeProcessing = require('./UnsubscribeProcessing');

var _UnsubscribeProcessing2 = _interopRequireDefault(_UnsubscribeProcessing);

var _UnsubscribeSuccess = require('./UnsubscribeSuccess');

var _UnsubscribeSuccess2 = _interopRequireDefault(_UnsubscribeSuccess);

var _UnsubscribeError = require('./UnsubscribeError');

var _UnsubscribeError2 = _interopRequireDefault(_UnsubscribeError);

require('./UnsubscribeModal.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        dispatchRefreshCurrentUser: function dispatchRefreshCurrentUser() {
            return dispatch((0, _currentUserActions.refreshCurrentUser)());
        }
    };
};

var unsubscribeHandlers = {
    onUnsubscribeButtonClick: function onUnsubscribeButtonClick(props) {
        return function (event) {
            var subscription = props.subscription,
                dispatchRefreshCurrentUser = props.dispatchRefreshCurrentUser,
                setLoading = props.setLoading,
                setSuccess = props.setSuccess,
                setLoadingError = props.setLoadingError;


            setLoading();

            (0, _paymentService.deleteSubscription)({ subscriptionId: subscription.get('id') }).then(function (response) {
                setSuccess();
                dispatchRefreshCurrentUser();
            }).catch(function (error) {
                console.error(error);
                setLoadingError(error);
            });
        };
    },
    onErrorButtonClick: function onErrorButtonClick(props) {
        return function (event) {
            props.setInitial();
            props.clearLoadingError();
        };
    }
};

var UnsubscribeModal = function UnsubscribeModal(props) {
    return _react2.default.createElement(
        'div',
        { className: 'UnsubscribeModal' },
        _react2.default.createElement(_LoadingTransitionDisplay2.default, _extends({}, props, {
            InitialComponent: _UnsubscribeConfirm2.default,
            LoadingComponent: _UnsubscribeProcessing2.default,
            SuccessComponent: _UnsubscribeSuccess2.default,
            ErrorComponent: _UnsubscribeError2.default }))
    );
};

var enhance = (0, _recompose.compose)(_loadingTransitionDecorator2.default, (0, _reactRedux.connect)(_paymentSelector.unsubscribeSelector, mapDispatchToProps), (0, _recompose.withHandlers)(unsubscribeHandlers));

exports.default = enhance(UnsubscribeModal);


//////////////////
// WEBPACK FOOTER
// ./src/client/user/account/unsubscribe/UnsubscribeModal.js
// module id = 2101
// module chunks = 0